import { AfterViewChecked, Component, OnInit, ViewChild } from '@angular/core';
import { ImageOverlayComponent } from '../components/image-overlay/image-overlay.component';

@Component({
  selector: 'app-test-page',
  templateUrl: './test-page.component.html',
  styleUrls: ['./test-page.component.scss']
})
export class TestPageComponent implements OnInit, AfterViewChecked {

  @ViewChild('imageOverlay', { read: ImageOverlayComponent, static: true }) imageOverlay: ImageOverlayComponent;

  period: string;
  gaugeConfig: any = {
    value:10,
    min:0,
    max:20
  };
  imageOverlayConfig: any[] = [{
    uri:'123',
    displayOption: 'dot',
    value: 10,
    x:10,
    y:10,
    default:{
      min:0,
      max:12
    }
  }]

  constructor() { }
  
  ngAfterViewChecked(): void {
    this.imageOverlay.updateTSData(this.imageOverlayConfig[0]);
  }

  ngOnInit(): void {
    
  }

}
